import { get, post } from "@/utils/utils";

const serviceReservation = {
  state: {
    wechatReqParams: []
  },
  mutations: {
    SAVE_SERVICE_RESTORATION_TYPE() {},
    QUERY_SERVICE_RESTORATION_TYPE_LIST() {},
    EDIT_SERVICE_RESTORATION_TYPE() {},
    SAVE_SERVICE_RESTORATION_PROJECT() {},
    QUERY_SERVICE_RESTORATION_PROJECT_LIST() {},
    GET_SERVICE_RESTORATION_PROJECT_INFO() {},
    EDIT_SERVICE_RESTORATION_PROJECT() {},
    QUERY_SERVICE_PROJECT_APPLY_RECORD_LIST() {},
    QUERY_SERVICE_PROJECT_DATA_STATISTICS() {},
    QUERY_SERVICE_RESTORATION_PROJECT_SHOP_LIST() {},
    QUERY_SERVICE_RESTORATION_PROJECT_EMP_LIST() {},
    QUERY_SERVICE_RESTORATION_PROJECT_TIME_QUANTUM_LIST() {},
    VERIFY_SERVICE_PROJECT_APPLY_BY_ID() {},
    QUERY_SERVICE_PROJECT_FORM_INPUT_RECORD() {},
    IMPORT_EMPLOYEE_SCHEDULING_DATA() {},
    GETSCHEDULING_INFO_LIST_BYSHOP_ID() {},
    REMOVE_EMPLOYEE_SCHEDULING_DATA() {},
    IMG2_BASE64() {},
    STORE_SERVICE_SHOP_ADD(){},
    QUERY_SERVICE_SHOP_LIST(){},
    STORE_SERVICE_PROJECT_INFO_QUERY_PAGE_LIST(){},
    ADD_SERVICE_PROJECT_INFO(){},
    STORE_SERVICE_PROJECT_INFO_QUERY_BY_ID(){},
    EDIT_SERVICE_DATE_RULE(){},
    QUERY_SERVICE_PROJECT_INFO_SHOP_PAGE(){},
    STORE_SERVICE_DATE_RULE_ADD(){},
    QUERY_SERVICE_DATE_RULE_LIST(){},
    STORE_SERVICE_DATE_RULE_EDIT(){},
    LIST_OF_STORES_TO_MAKE_APPOINTMENTS(){},
    SAVE_SERVICE_PROJECT_INFO_DATE_RULE_REL(){},
    UPDATE_SERVICE_SHOP_IS_ENABLE() {},
    QUERY_SERVICE_RESTORATION_PROJECT_EMP_LIST_TENANT(){},
    QUERY_SERVICE_RESTORATION_PROJECT_SHOP_LIST_TENANT(){},
    GET_SERVICE_RESTORATION_TYPE_NODE_LIST_BY_STORE_CODE(){},
    GET_MODEL_BY_PARAM_CODE(){},
    QUERY_SERVICE_RESTORATION_TYPE_PAGE_LIST(){},
    SHARE_SERVICE_PROJECT_SHOP_SERVICES(){},
    STORE_SERVICE_RESTORATION_EXPORT() {},
  },
  actions: {
       //分类服务
       storeServiceRestorationExport({ commit }, params) {
        return post({
          commit,
          url: `/provider/tenant/store/serviceRestoration/storeServiceRestorationExport`,
          name: "STORE_SERVICE_RESTORATION_EXPORT",
          params
        });
      },


      //查看详情
      // getModelByParamCode({ commit }, params) {
      //   return post({
      //     commit,
      //     url: `/storepermissions/storeSystemParamInfo/getModelByParamCode`,
      //     name: "GET_MODEL_BY_PARAM_CODE",
      //     params
      //   });
      // },
     //分类服务
     getServiceRestorationTypeNodeListByStoreCode({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/store/serviceRestoration/getServiceRestorationTypeNodeListByStoreCode`,
        name: "GET_SERVICE_RESTORATION_TYPE_NODE_LIST_BY_STORE_CODE",
        params
      });
    },

     //服务门店
    queryServiceRestorationProjectShopListTenant({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/store/serviceRestoration/queryServiceRestorationProjectShopList`,
        name: "QUERY_SERVICE_RESTORATION_PROJECT_SHOP_LIST_TENANT",
        params
      });
    },


    //查询预约服务项目技师列表
    queryServiceRestorationProjectEmpListTenant({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/store/serviceRestoration/queryServiceRestorationProjectEmpList`,
        name: "QUERY_SERVICE_RESTORATION_PROJECT_EMP_LIST_TENANT",
        params
      });
    },
  
    //保存服务预约类型
    saveServiceRestorationType({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceRestoration/saveServiceRestorationType`,
        name: "SAVE_SERVICE_RESTORATION_TYPE",
        params
      });
    },
    
    //查询服务列表
    storeServiceProjectInfoQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeServiceProjectInfo/queryPageList`,
        name: "STORE_SERVICE_PROJECT_INFO_QUERY_PAGE_LIST",
        params
      });
    },

    //新增时段规则
    storeServiceDateRuleAdd({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeServiceDateRule/add`,
        name: "STORE_SERVICE_DATE_RULE_ADD",
        params
      });
    },
    // 查询时间规则列表
    queryServiceDateRuleList({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeServiceDateRule/queryServiceDateRuleList`,
        name: "QUERY_SERVICE_DATE_RULE_LIST",
        params
      });
    },

    saveServiceProjectInfoDateRuleRel({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeServiceProjectInfo/saveServiceProjectInfoDateRuleRel`,
        name: "SAVE_SERVICE_PROJECT_INFO_DATE_RULE_REL",
        params
      });
    },


    storeServiceDateRuleEdit({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeServiceDateRule/edit`,
        name: "STORE_SERVICE_DATE_RULE_EDIT",
        params
      });
    },

    listOfStoresToMakeAppointments({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeServiceShop/queryServiceShopList`,
        name: "LIST_OF_STORES_TO_MAKE_APPOINTMENTS",
        params
      });
    },

    updateServiceShopIsEnable({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeServiceShop/updateServiceShopIsEnable`,
        name: "UPDATE_SERVICE_SHOP_IS_ENABLE",
        params
      });
    },

     //新增服务预约
     addServiceProjectInfo({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeServiceProjectInfo/addServiceProjectInfo`,
        name: "ADD_SERVICE_PROJECT_INFO",
        params
      });
    },
    // 查询服务详情
    storeServiceProjectInfoQueryById({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeServiceProjectInfo/queryById`,
        name: "STORE_SERVICE_PROJECT_INFO_QUERY_BY_ID",
        params
      });
    },

    // 编辑服务详情
    editServiceDateRule({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeServiceProjectInfo/editServiceDateRule`,
        name: "EDIT_SERVICE_DATE_RULE",
        params
      });
    },
      // 删除商店
      delServiceProjectShopServices({ commit }, params) {
        return post({
          commit,
          url: `/provider/tenant/serviceRestoration/storeServiceShop/delServiceProjectShop`,
          name: "SHARE_SERVICE_PROJECT_SHOP_SERVICES",
          params
        });
      },
  
    // 查询授权商店 
    queryServiceProjectInfoShopPage({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeServiceShop/queryServiceProjectInfoShopPage`,
        name: "QUERY_SERVICE_PROJECT_INFO_SHOP_PAGE",
        params
      });
    },



     //查询服务项目分类列表
     queryServiceRestorationTypePageList({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceRestoration/queryServiceRestorationTypePageList`,
        name: "QUERY_SERVICE_RESTORATION_TYPE_PAGE_LIST",
        params
      });
    },


    //查询服务项目分类列表
    queryServiceRestorationTypeList({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceRestoration/queryServiceRestorationTypeList`,
        name: "QUERY_SERVICE_RESTORATION_TYPE_LIST",
        params
      });
    },
    storeServiceShopAdd({ commit }, params) {
      return post({
        commit,
        url: `/serviceRestoration/storeServiceShop/addBatch`,
        name: "STORE_SERVICE_SHOP_ADD",
        params
      });
    },

    queryServiceShopList({ commit }, params) {
      return post({
        commit,
        url: `/serviceRestoration/storeServiceShop/queryServiceShopList`,
        name: "QUERY_SERVICE_SHOP_LIST",
        params
      });
    },



    //编辑服务预约类型
    editServiceRestorationType({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceRestoration/editServiceRestorationType`,
        name: "EDIT_SERVICE_RESTORATION_TYPE",
        params
      });
    },
    saveServiceRestorationProject({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceRestoration/saveServiceRestorationProject`,
        name: "SAVE_SERVICE_RESTORATION_PROJECT",
        params
      });
    },
    //保存商城预约服务项目
    saveServiceRestorationProject({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceRestoration/saveServiceRestorationProject`,
        name: "SAVE_SERVICE_RESTORATION_PROJECT",
        params
      });
    },
    //查询预约服务项目列表
    queryServiceRestorationProjectList({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceRestoration/queryServiceRestorationProjectList`,
        name: "QUERY_SERVICE_RESTORATION_PROJECT_LIST",
        params
      });
    },
    //查询预约服务项目详情
    getServiceRestorationProjectInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceRestoration/getServiceRestorationProjectInfo`,
        name: "GET_SERVICE_RESTORATION_PROJECT_INFO",
        params
      });
    },
    //编辑商城预约服务项目
    editServiceRestorationProject({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceRestoration/editServiceRestorationProject`,
        name: "EDIT_SERVICE_RESTORATION_PROJECT",
        params
      });
    },
    //查询服务项目预约明细列表
    queryServiceProjectApplyRecordList({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceRestoration/queryServiceProjectApplyRecordList`,
        name: "QUERY_SERVICE_PROJECT_APPLY_RECORD_LIST",
        params
      });
    },
    //查询服务预约报名数据统计
    queryServiceProjectDataStatistics({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceRestoration/queryServiceProjectDataStatistics`,
        name: "QUERY_SERVICE_PROJECT_DATA_STATISTICS",
        params
      });
    },
    //查询预约服务项目门店列表
    queryServiceRestorationProjectShopList({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceRestoration/queryServiceRestorationProjectShopList`,
        name: "QUERY_SERVICE_RESTORATION_PROJECT_SHOP_LIST",
        params
      });
    },



    //查询预约服务项目技师列表
    queryServiceRestorationProjectEmpList({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceRestoration/queryServiceRestorationProjectEmpList`,
        name: "QUERY_SERVICE_RESTORATION_PROJECT_EMP_LIST",
        params
      });
    },
    //查询预约服务项目时间段列表
    queryServiceRestorationProjectTimeQuantumList({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceRestoration/queryServiceRestorationProjectTimeQuantumList`,
        name: "QUERY_SERVICE_RESTORATION_PROJECT_TIME_QUANTUM_LIST",
        params
      });
    },
    //查询预约服务项目时间段列表
    verifyServiceProjectApplyById({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceRestoration/verifyServiceProjectApplyById`,
        name: "VERIFY_SERVICE_PROJECT_APPLY_BY_ID",
        params
      });
    },
    //查询会员服务预约报名表单
    queryServiceProjectFormInputRecord({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceRestoration/queryServiceProjectFormInputRecord`,
        name: "QUERY_SERVICE_PROJECT_FORM_INPUT_RECORD",
        params
      });
    },
    //编辑商城预约服务项目表格导入
    importEmployeeSchedulingData({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceRestoration/importEmployeeSchedulingData`,
        name: "IMPORT_EMPLOYEE_SCHEDULING_DATA",
        params
      });
    },
    //编辑商城预约服务项目表格查询
    getschedulingInfoListByshopId({ commit }, params) {
      return post({
        commit,
        url: `/provider/guider/micro/serviceRestoration/getschedulingInfoListByshopId`,
        name: "GETSCHEDULING_INFO_LIST_BYSHOP_ID",
        params
      });
    },
    //删除表格导入数据
    removeEmployeeSchedulingData({ commit }, params) {
      return post({
        commit,
        url: `/serviceRestoration/storeServiceRestorationProjectSchedulingInfo/removeEmployeeSchedulingData`,
        name: "REMOVE_EMPLOYEE_SCHEDULING_DATA",
        params
      });
    },
    img2base64({ commit }, params) {
      return post({
        commit,
        url: `/micro/zlb/img2base64`,
        name: "IMG2_BASE64",
        params
      });
    },
  }
};

export default serviceReservation;
